import React from 'react';
import { Paper, Box, Grid, Button } from '@mui/material/';
import { connect } from "react-redux";
import { Redirect, useHistory } from 'react-router-dom';
import ElementoDeIcono from 'components/ElementoDeIcono';
import FormTemplate from './FormElements/';
import mapStateToProps from './mapStateToProps';
import { useStyles } from './style';




const Login = (props) => {
  const classes = useStyles(props);
  const history = useHistory();

  const recuperarContraseña = () => {
    window.location.href = "https://portalweb.tse.org.gt/cambiarContrase%C3%B1a/obtenerCorreoExterno";
  }
  if (props.authenticated)
    return (
      <Redirect
        to={{
          pathname: "/",
          state: { from: props.location, authenticated: props.authenticated }
        }} />
    );
  else
    return (
      <Grid container component="main" sx={{ height: '100vh' }} className={classes.contenedorInicioSesion}>
        <Grid item xs={12} sm={8} md={5} component={Paper} square >
          <Box className={classes.contenedorDeCaja}>
            <div className={classes.contenedorFormulario}>
              <ElementoDeIcono />
              <h1 className={classes.title}>¡Bienvenido!</h1>
              <FormTemplate />
              <Button
                onClick={recuperarContraseña}
                color="primary"
                sx={{ display: "block", margin: "0 auto" }}
              >
                ¿Has olvidado tu contraseña?
              </Button>
            </div>
          </Box>
        </Grid>
      </Grid>
    )
}
export default connect(mapStateToProps)(Login);